/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */
//入口
import { rechargeRecordList } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

/*新增消息推送*/
// let addMessage = {
//   name: '新增场景',
//   icon: 'el-icon-plus',
//   type: 'primary',
//   fn: (app, table) => {
//     table.$router.push({
//       query: {
//         edit: 1
//       }
//     });
//   }
// };

//初始化
export let example = new TableRenderClass({ fields, search });

// 页面入口
let homePagePart = example.createPart({
  name: '可配置场景管理',
  search: ['payName', 'tradeNo', 'monthrange'],
  list: rechargeRecordList,
  requestNow: true,
  fields: [
    'index',
    'bankAccName',
    // 'bankAcctNo',
    'companyName',
    'bfBankNumber',
    'outTradeNo',
    'finishPayDt',
    'amount',
    'payPassagewayCode',

    'operation'
  ]
});
/*主页面入口*/
export const main = [{ name: '可配置场景管理', childMenu: [homePagePart] }];
